/* Self-paced fake progress: climbs toward `cap` and holds until `complete` flips true, then ramps to 100. */
import { useEffect, useState } from "react";

export function useSimulatedProgress(cap = 92, intervalMs = 220, complete = false) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const target = complete ? 100 : cap;
    const id = setInterval(() => {
      setPct((p) => (p >= target ? target : p + Math.max(1, Math.round((target - p) / 10))));
    }, intervalMs);
    return () => clearInterval(id);
  }, [cap, intervalMs, complete]);
  return pct;
}
